/**
 * The order pipeline, mirroring app/Modules/Orders/Domain/OrderStatus.php.
 *
 * These fifteen strings are a contract. They appear in the API, in the rider
 * app's offline queue, and on the merchant's screen. Renaming one is a data
 * migration and a merchant conversation, not a refactor — see PLAN.md §4,
 * "expensive, think first".
 */
export const ORDER_STATUSES = [
    'new',
    'ready_for_pickup',
    'picked_up',
    'arrived_at_hub',
    'out_for_delivery',
    'delivered',
    'declined',
    'rescheduled',
    'on_hold',
    'returned_to_hub',
    'cash_reconciled',
    'remitted',
    'declined_by_merchant',
    'declined_on_way_to_merchant',
    'declined_returned_to_merchant',
    'lost',
    'archived',
] as const;

export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
    new: 'New',
    ready_for_pickup: 'Ready for Pickup',
    picked_up: 'Picked Up',
    arrived_at_hub: 'Arrived at Hub',
    out_for_delivery: 'Out for Delivery',
    delivered: 'Delivered',
    declined: 'Declined',
    rescheduled: 'Rescheduled',
    on_hold: 'On Hold',
    returned_to_hub: 'Returned to Hub',
    cash_reconciled: 'Cash Reconciled',
    remitted: 'Remitted',
    declined_by_merchant: 'Declined by Merchant',
    declined_on_way_to_merchant: 'Declined on way to merchant',
    declined_returned_to_merchant: 'Declined — Returned to Merchant',
    lost: 'Lost',
    archived: 'Archived',
};

const TERMINAL: ReadonlySet<OrderStatus> = new Set([
    'remitted',
    'declined_returned_to_merchant',
    'lost',
    'archived',
]);

export function isTerminal(status: OrderStatus): boolean {
    return TERMINAL.has(status);
}

export function isOpen(status: OrderStatus): boolean {
    return !isTerminal(status);
}

/** COD cash position, tracked separately from the pipeline. */
export const CASH_STATUSES = ['na', 'pending', 'collected', 'settled'] as const;
export type CashStatus = (typeof CASH_STATUSES)[number];

export type PaymentType = 'cod' | 'prepaid';
